import * as React from 'react';
import { createElement } from 'react';
import Typed from 'typed.js';
TypedText.defaultProps = {
    typeSpeed: 100,
    showCursor: false,
};
function TypedText(props) {
    const el = React.useRef(null);
    const [typed, setTyped] = React.useState(null);
    const { text, typeSpeed, showCursor, ...otherProps } = props;
    React.useEffect(() => {
        const tempTyped = new Typed(el.current, {
            strings: [text],
            typeSpeed,
            showCursor,
            ...otherProps
        });
        setTyped(tempTyped);
        return () => {
            typed?.destroy();
        };
    }, [text]);
    return (createElement("div", { className: "type-text-wrapper" },
        createElement("span", { ref: el })));
}
export default TypedText;
